import type React from 'react'

const UNSLoader: React.FC = () => {
  return (
    <div className="uns-loader" style={{ marginTop: '2.5rem' }}>
      <div className="uns-box">
        <div className="uns-logo font-bold">UNS</div>
      </div>
      <div className="uns-box" />
      <div className="uns-box" />
      <div className="uns-box" />
      <div className="uns-box" />
    </div>
  )
}

export default UNSLoader
